import { Stack } from "@mui/material";
import useIsCreate from "hooks/useIsCreate";
import { useMemo, useState } from "react";
import BackPageButton from "components/buttons/BackPageButton";
import ROUTES from "constants/routes";
import { useSearchParams } from "react-router-dom";
import qs from "qs";
import { useCandidateHeaderQuery } from "@generated/graphql";
import Header from "./components/Header";
import Content from "./components/Content";
import CandidatesList from "./components/CandidateList";
import { VacancyCompanyCandidatesRefetch } from "./types";

const CandidateView = () => {
  const isCreate = useIsCreate();
  const [vacancyCompanyCandidatesRefetch, setVacancyCompanyCandidatesRefetch] =
    useState<VacancyCompanyCandidatesRefetch | null>(null);
  const [searchParams] = useSearchParams();
  const params = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);
  const { candidateId } = params as { candidateId?: string };

  const { data: candidateHeaderData } = useCandidateHeaderQuery({
    variables: { candidateId: candidateId! },
    skip: !candidateId,
  });
  const candidate = candidateHeaderData?.companyCandidate;

  const getBackPageButtonProps = () => {
    if (candidateId) {
      return {
        text: `Кандидат ${candidate?.fullName}`,
        link: `/${ROUTES.CANDIDATE}/view/${candidateId}`,
      };
    }

    return {
      text: "Список вакансий",
      link: `/${ROUTES.VACANCIES}`,
    };
  };

  return (
    <>
      <BackPageButton {...getBackPageButtonProps()} />
      <Stack spacing={2.5}>
        <Header />
        <Content vacancyCompanyCandidatesRefetch={vacancyCompanyCandidatesRefetch} />
        {!isCreate && <CandidatesList setVacancyCompanyCandidatesRefetch={setVacancyCompanyCandidatesRefetch} />}
      </Stack>
    </>
  );
};

export default CandidateView;
